'use client'

import type { MaskProps } from '@pearlconvert/ui/components/mask/mask.types'

import React, { CSSProperties } from 'react'

import { useMask } from '@pearlconvert/ui/components/mask/batons/use-mask'

import '@pearlconvert/ui/components/mask/styles/mask.scss'

const Mask: React.FC<MaskProps> = ({
  elevation,
  isActive: initialActive,
  onDismiss,
  onStatusChange,
  ...rest
}) => {
  const { isActive, dismissMask, handleKeyDown } = useMask({
    initialActive,
    onDismiss,
    onStatusChange,
  })

  return (
    <button
      className={`mask${isActive ? ' mask--active' : ''}`}
      onClick={dismissMask}
      tabIndex={-1}
      aria-hidden={true}
      onKeyDown={handleKeyDown}
      {...(elevation && {
        style: { '--js-mask-elevation': elevation } as CSSProperties,
      })}
      {...rest}
    />
  )
}

export default Mask
